<template>
	<div class="mainBd">
		<van-tabs class="tabsCon" v-if="status.isMobileTotp" @click="onClick" v-model="active" swipeable>
			<van-tab title="手机动态密码登录">
				<vk-mobile></vk-mobile>
			</van-tab>
			<van-tab title="身份宝认证登录">
				<vk-totp></vk-totp>
			</van-tab>
		</van-tabs>
		<vk-mobile v-if="status.isMobile"></vk-mobile>
	</div>
</template>

<script>
import { mapState } from 'vuex';
import _ from 'lodash';
import VkMobile from './mobileCode.vue';
import VkTotp from './totpCode.vue';

export default {
  name: 'modeLayout',
  data() {
    return {
      active: 0
    }
  },
  computed: {
    ...mapState('login', ['userinfo']),
    status() {
      const mfaType = _.get(this.userinfo, 'mfaType') || [];
      const totpBind = _.get(this.userinfo, 'totpBind');
      return {
        isMobileTotp: mfaType.includes('mobile') && mfaType.includes('totp')  && totpBind === 1,
        isMobile: mfaType.includes('mobile') && totpBind !== 1
      }
    }
  },
  methods: {
    onClick(index, title) {
      // this.$toast(title);
    }
  },
  components: {
    VkMobile,
    VkTotp
  }
}
</script>

<style lang="scss" scoped>
	.mainBd {
		max-width: 375px;
		margin: 0 auto;
		-webkit-box-sizing: border-box;
		-moz-box-sizing: border-box;
		box-sizing: border-box;
	}
	.tabsCon /deep/ .van-tabs__content {
		margin-top: -10px;
	}
</style>
